export default {
    topics: [
        {
            title: ' Script ',
            href: 'p-34.html',
            attributes: { 'data-id': 'p-34' },
            menu: { hasChildren: false },
            tocID: 'p-34-d66e7589',
            topics: [],
        },
        {
            title: ' Expression ',
            href: 'p-35.html',
            attributes: { 'data-id': 'p-35' },
            menu: { hasChildren: false },
            tocID: 'p-35-d66e7597',
            topics: [],
        },
        {
            title: ' Directive page ',
            href: 'p-36.html',
            attributes: { 'data-id': 'p-36' },
            menu: { hasChildren: false },
            tocID: 'p-36-d66e7605',
            topics: [],
        },
    ],
};

